
(function () {
  const MQ = "(max-width: 749px)";
  const MOBILE_SLIDES = 4.5;
  const MOBILE_GAP = 14;

  const FORCE_SIZE = false;
  const SLIDE_SIZE = 72;
  const GAP = 18;

  const LEFT_PADDING = 20;

  function isMobile() {
    return matchMedia(MQ).matches;
  }

  function collectSwiperEls(root, out) {
    if (!root) return;
    if (root.querySelectorAll) {
      root.querySelectorAll(".swiper").forEach(el => out.add(el));
      root.querySelectorAll("*").forEach(el => {
        if (el.shadowRoot) collectSwiperEls(el.shadowRoot, out);
      });
    }
  }

  // 🔒 filtro: só o swiper das bolhas (camada 1)
  function isBubblesSwiper(swiper) {
    const el = swiper && swiper.el;
    if (!el || !el.classList) return false;
    return el.classList.contains("lyvecom-bubbles"); // <- chave
  }

  function applyBubblesStyle(swiper) {
    if (!FORCE_SIZE) return;

    // só no mobile
    if (!isMobile()) {
      swiper.slides?.forEach(slide => {
        slide.style.width = "";
        slide.style.marginRight = "";
      });
      return;
    }

    swiper.slides?.forEach(slide => {
      slide.style.width = SLIDE_SIZE + "px";
      slide.style.marginRight = GAP + "px";
    });
  }

  function apply(swiper) {
    if (!swiper || swiper.destroyed) return false;

    // 🔒 não deixa afetar swipers internos
    if (!isBubblesSwiper(swiper)) return false;

    // guarda originais
    if (!swiper.__orig) {
      swiper.__orig = {
        slidesPerView: swiper.params.slidesPerView,
        spaceBetween: swiper.params.spaceBetween
      };
    }

    function isProductPage() {
        return document.body.classList.contains('template-product') ||
                !!document.querySelector('product-info');
        }

        if (isMobile()) {
        swiper.params.slidesPerView = MOBILE_SLIDES;
        swiper.params.spaceBetween = MOBILE_GAP;

        if (isProductPage()) {
            swiper.el.style.paddingLeft = "2px";
            swiper.el.style.marginRight = "-20px"
        } else {
            swiper.el.style.paddingLeft = "20px";
        }

        swiper.el.style.boxSizing = "border-box";

        } else {
        swiper.params.slidesPerView = swiper.__orig.slidesPerView;
        swiper.params.spaceBetween = swiper.__orig.spaceBetween;

        swiper.el.style.paddingLeft = "";
        swiper.el.style.boxSizing = "";
        }

        applyBubblesStyle(swiper);
        swiper.update();
    return true;
  }

  function run() {
    const els = new Set();
    collectSwiperEls(document, els);

    let ok = false;
    els.forEach(el => {
      if (el && el.swiper) {
        if (apply(el.swiper)) ok = true;
      }
    });

    return ok;
  }

  // tenta por alguns segundos (widget monta depois)
  let tries = 0;
  const maxTries = 80; // ~20s

  const timer = setInterval(() => {
    tries++;
    run();
    if (tries >= maxTries) clearInterval(timer);
  }, 250);

  // reaplica em resize/orientation
  let t;
  addEventListener("resize", () => {
    clearTimeout(t);
    t = setTimeout(run, 150);
  });

  addEventListener("orientationchange", () => setTimeout(run, 250));
})();


(function () {

  function injectHideArrows(root) {
    if (!root || root.__arrowsHidden) return;

    const style = document.createElement("style");
    style.textContent = `
      .swiper-button-next,
      .swiper-button-prev {
        display: none !important;
      }
    `;

    root.appendChild(style);
    root.__arrowsHidden = true;
  }

  function walk(root) {
    if (!root) return;

    if (root.querySelectorAll) {
      root.querySelectorAll("*").forEach(el => {
        if (el.shadowRoot) {
          injectHideArrows(el.shadowRoot);
          walk(el.shadowRoot);
        }
      });
    }
  }

  let tries = 0;
  const maxTries = 60;

  const timer = setInterval(() => {
    walk(document);
    tries++;
    if (tries >= maxTries) clearInterval(timer);
  }, 250);

})();